import IntersectionObserver from '@core/util/intersection-observer';

export default class LazyLoadUtil {
  constructor(el) {
    this.el = el;
  }

  onView(triggerFn) {
    this.triggerFn = triggerFn;
    this.createObserver();
  }

  createObserver() {
    const observer = new IntersectionObserver(() => {
      this.triggerFn();
      observer.unsubscribe(this.el);
    });

    observer.ready.then(() => {
      observer.subscribe(this.el);
    });
  }
}
